// components
import HeadText from "../components/HeadText";
import Sub from "../components/Sub";
import ChildTitle from "../components/ChildTitle";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { MakerContent, TokenMobileContent } from "../components/culturemaker";
// material
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function CulturemakerPage({
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <>
      {isDesktop && (
        <>
          <Header
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
          />

          <div className="page">
            <HeadText title={"CULTURE"} />
            <Sub
              title1={"WE INCUBATE"}
              title2={"COMMUNITY-OWNED"}
              title3={"BRANDS AND CULTURE"}
            />
            <ChildTitle title={"MAKER"} />
            <MakerContent />
          </div>

          <Footer />
        </>
      )}
      {!isDesktop && (
        <>
          <Header
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
            text={"TOKEN"}
          />
          <TokenMobileContent
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
          />
        </>
      )}
    </>
  );
}
